import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { MiniCartStyles } from "@omni/ui/brand/cart/miniCart/miniCart.styles";
import { Anchor } from "@omni/ui/components/Anchor/anchor.component";
import { Button } from "@omni/ui/components/Button/button.component";
import { Divider } from "@omni/ui/components/Divider/divider.component";
import { cn } from "@omni/utils/styles";

import { ShoppingCartSummary } from "@/components/Cart/ShoppingCartSummary/shoppingCartSummary.component";
import { Spinner } from "@/components/General/Spinner/spinner.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type MiniCartProps = {
    loading: boolean;
    cart?: Cart | null;
    hasCartItems: boolean;
    urlTarget?: string;
    isUpdatingCart?: { [key: string]: boolean };
    activeId: string;
    removeFromCart?: (id: string, quantity: number, free: boolean) => void;
    closeCallback?: () => void;
};

const MiniCartComponent = ({
    loading,
    cart,
    hasCartItems,
    urlTarget,
    isUpdatingCart,
    activeId,
    removeFromCart,
    closeCallback
}: MiniCartProps) => {
    const { t } = useGranite();

    const cartKey = cart?.items.map((item) => item.id).join(",") ?? "";

    return (
        <>
            <Divider className={cn("tw:mb-4")} />
            <section className={cn("tw:grow tw:overflow-hidden tw:-mr-4")}>
                {loading && (
                    <div className={cn("tw:text-center tw:px-3")}>
                        <Spinner />
                    </div>
                )}
                {!loading && (
                    <ShoppingCartSummary
                        key={cartKey}
                        productLinkingAvailable={true}
                        isMiniCart={true}
                        shoppingCart={cart}
                        removeFromCart={removeFromCart}
                        isUpdatingCart={isUpdatingCart}
                        activeId={activeId}
                        className={cn("tw:lg:max-h-[calc(100vh-200px)]")}
                    />
                )}
            </section>
            <section className={cn("tw:pt-4 tw:flex tw:gap-4")}>
                <Button
                    color={"link"}
                    onClick={closeCallback}
                    className={cn(
                        "tw:absolute tw:top-3 tw:left-4 tw:p-0 tw:w-full tw:text-left!",
                        "tw:lg:relative tw:lg:top-auto tw:lg:left-auto tw:lg:grow tw:lg:text-center"
                    )}
                >
                    <i className={cn("las la-angle-left")} />
                    {t("general.miniCart.button.continue")}
                </Button>
                {hasCartItems && (
                    <Anchor
                        color={MiniCartStyles.orderButton?.color ?? "secondary"}
                        href={urlTarget}
                        fullWidth={true}
                        className={cn("tw:grow tw:w-full")}
                    >
                        {t("general.miniCart.button.order")}
                    </Anchor>
                )}
            </section>
        </>
    );
};

export { MiniCartComponent };
